import type { CoreError } from '@ingenico/api-sdk-core/common';
import type { EnumCallStatusApi, SearchRequestSortApi } from '@ingenico/api-sdk-device-management-private-v2';
import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import type { GridSortModel } from '@mui/x-data-grid-pro';
import type { TFunction } from 'react-i18next';

export interface TransformFiltersParams {
  readonly selectedQuickFilterValue?: EnumCallStatusApi[];
  readonly searchQuery?: string;
  readonly startDate: number;
  readonly endDate: number;
}

export function getField(field: string): string {
  const fieldMappings: Record<string, string> = {
    date: 'deviceDiagnostics.date',
    module: 'deviceDiagnostics.module',
    serialNumber: 'deviceDiagnostics.serialNumber',
    testCategories: 'deviceDiagnostics.testCategories',
    success: 'deviceDiagnostics.testCategories',
    warning: 'deviceDiagnostics.testCategories',
    error: 'deviceDiagnostics.testCategories',
    notApplicable: 'deviceDiagnostics.testCategories',
  };

  return fieldMappings[field] || `deviceDiagnostics.${field}`;
}

export const defaultDeviceDiagnosticsListContentSort: GridSortModel = [
  {
    field: 'date',
    sort: 'desc',
  },
];
export function transformSortModelForRequest(gridSort: GridSortModel): SearchRequestSortApi {
  const [currentSort] = gridSort;
  return currentSort?.sort
    ? {
        field: getField(currentSort.field),
        order: currentSort.sort === 'asc' ? 'ASC' : 'DESC',
      }
    : transformSortModelForRequest(defaultDeviceDiagnosticsListContentSort);
}

export function getDeviceDiagnosticsListContentErrorMsg(t: TFunction, error?: CoreError | null): string {
  switch (error?.status) {
    case 404: {
      return t('error.default.deviceCallLogsDataNotFound', { ns: ALL_LNGS_NAMESPACES.LOGICAL_DEVICE });
    }
    default: {
      return t('error.default.fetchDeviceCallLogsData', { ns: ALL_LNGS_NAMESPACES.LOGICAL_DEVICE });
    }
  }
}
